/**
 * 用来统一处理，被驳回，撤销后，再次发起的单据，哪些字段可编辑，哪些不可编辑
 * 黑名单：某些字段，不可编辑
 * 白名单：仅有这些字段可以编辑，其他所有字段都不可编辑；(仅品控驳回)
 */

import { shared } from '../shareState';

const isEmpty = (value) => value === '' || value === 0 || value === -1 || (Array.isArray(value) && !value.length) || value === undefined || value === null;
const keysCache = [];

export default {
    computed: {
        MixinAttrsWhiteList() {
            const { rejectedCanNotEditAttrs = {} } = shared;
            if (rejectedCanNotEditAttrs.whitelist && rejectedCanNotEditAttrs.whitelist.length) return rejectedCanNotEditAttrs.whitelist;
            return [];
        },
        MixinAttrsBlackList() {
            const { rejectedCanNotEditAttrs = {} } = shared;
            if (rejectedCanNotEditAttrs.blacklist && rejectedCanNotEditAttrs.blacklist.length) return rejectedCanNotEditAttrs.blacklist;
            return [];
        },
        MixinHasWhiteList() {
            if (this.MixinAttrsWhiteList.length) return true;
            return false;
        },
        MixinHasBlackList() {
            if (this.MixinAttrsBlackList.length) return true;
            return false;
        },
        MixinJudgeRejectedFormDisabled() {
            return this.MixinHasWhiteList;
        },
    },
    methods: {
        /**
         *
         * @param {String} key 用于匹配黑白名单的字段
         * @param {any} value 表单值，用于判断必填，但是空值的场景
         * @param {Boolean} required 是否必填，用于判断必填，但是空值的场景
         * @param {String} cacheKey 用于缓存命 中必填但空值的字段，本次编辑均可以操作。默认值和key相同，当可能出现重复key的时候，需要手动命名传入
         * @returns Boolean
         */
        // eslint-disable-next-line consistent-return
        MixinJudgeRejectedAttrsDisabled(key, value, required = false, cacheKey = key) {
            if (required && isEmpty(value) && !keysCache.includes(cacheKey)) {
                keysCache.push(cacheKey);
            }
            if (keysCache.includes(cacheKey)) return false;
            const {
                MixinHasWhiteList, MixinHasBlackList, MixinAttrsWhiteList, MixinAttrsBlackList,
            } = this;
            if (!MixinHasWhiteList && !MixinHasBlackList) return false;
            // 存在白名单
            if (MixinHasWhiteList) {
                // 在白名单内的可以编辑，不在则禁用
                if (MixinAttrsWhiteList.includes(key)) return false;
                return true;
            }
            if (MixinHasBlackList) {
                // 在黑名单内禁用，不在则可以编辑
                if (MixinAttrsBlackList.includes(key)) return true;
                return false;
            }
        },
    },
};
